// Named brand colors for the Mantine theme. Mantine needs at least 10 shades per
// custom color or TypeScript and component variants can break.
// Use these as quiet UI colors, not as photo colors — photos remain the main
// source of saturation.

export const travelNavy = [
  '#EAF1F5',
  '#D2E0E8',
  '#A8C1D1',
  '#7CA0B7',
  '#587F99',
  '#3C617A',
  '#24465E',
  '#143047',
  '#0B1F31',
  '#05101A',
] as const;

export const travelCream = [
  '#FFFDF8',
  '#FFF9EE',
  '#FBF3E6',
  '#F7F0E3',
  '#EFE3D0',
  '#E4D2B8',
  '#D8C8AD',
  '#BFA989',
  '#9E8564',
  '#6F5A40',
] as const;

export const travelGold = [
  '#FFF6E8',
  '#F7E7CA',
  '#EED4A6',
  '#E4BF7F',
  '#D6A15C',
  '#C28A42',
  '#B8793A',
  '#915C2B',
  '#6E431E',
  '#3A2B1B',
] as const;

export const travelTeal = [
  '#EEF7F6',
  '#DDE8E8',
  '#BDD3D2',
  '#9ABBBE',
  '#7AA3AA',
  '#5E8892',
  '#426E79',
  '#294C5A',
  '#1D3A47',
  '#102333',
] as const;
